<template>
    <div
        :id="id"
        class="text-copy"
        :class="{ copied }"
        @click="copy"
    >
        <div :style="`text-align: ${alignment}`">
            {{ text }}
        </div>
        <i
            class="mi-copy"
            @click="copy"
        />
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    content: String,
    options: Object,
})

const text = computed(() => props.content)
const alignment = computed(() => props?.options?.alignment || '')

const copied = ref(false)

const copy = async () => {
    try {
        await navigator.clipboard.writeText(text.value)
        copied.value = true
        setTimeout(() => {
            copied.value = false
        }, 3000)
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to copy text:', err)
    }
}

</script>

<style lang="sass" scoped>
@import "./TextCopiable.sass"
</style>
